export const updateChatbotState = (setState, message) => {
    setState((prevState) => ({
        ...prevState,
        messages: [...prevState.messages, message],
    }));
};
